// src/authConfig.js

// Function to get MSAL config dynamically
export const getMsalConfig = () => {
  const clientId = localStorage.getItem("msOutlookClientId") || "";
  const tenantId = localStorage.getItem("msOutlookTenantId") || "";

  return {
    auth: {
      clientId: clientId,
      authority: `https://login.microsoftonline.com/${tenantId}`,
      redirectUri: window.location.origin,
    },
    cache: {
      cacheLocation: "localStorage",
      storeAuthStateInCookie: true,
    }
  };
};

// Export static config
export const msalConfig = getMsalConfig();

export const loginRequest = {
  scopes: ["User.Read", "Calendars.ReadWrite"],
};